import { FormRule } from "antd";

export const emailRules: FormRule[] = [
  { required: true, message: "El correu electrònic és necessari" },
  {
    type: "email",
    message: "No és un correu electrònic vàlid",
  },
];

export const passwordRules: FormRule[] = [
  { required: true, message: "La contrasenya és necessària" },
];
